import { CountUp } from 'countup.js';

if (!window.CountUp) {
  window.CountUp = CountUp;
}
export const counterUp = () => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  };
  // eslint-disable-next-line no-undef
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }
      const item = entry.target.querySelector('[data-is-disabled]');
      const options = item?.dataset?.options;
      if (!options) {
        return;
      }
      const counterOptions = JSON.parse(options);

      if (counterOptions.displayThousandSeparator) {
        counterOptions.separator = ',';
      }
      const countUp = new CountUp(item, counterOptions.endVal, counterOptions);

      if (!countUp.error && item.dataset.isDisabled === 'false') {
        countUp.start();
        io.unobserve(entry.target); // To disable counter animation permanently after the first round
      } else {
        item.textContent = counterOptions.endVal;
      }
      item.countUp = countUp;
    });
  }, options);

  const counters = document.querySelectorAll('.e-ctr');
  counters.forEach((el) => {
    io.observe(el);
  });
};

const counterDOMContentLoaded = () => {
  counterUp();
};

document.addEventListener('DOMContentLoaded', counterDOMContentLoaded);
